const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi41NCAyLjE1OWwxNCA5YTEgMSAwIDAgMSAwIDEuNjgybC0xNCA5QTEgMSAwIDAgMSA1IDIxVjNhMSAxIDAgMCAxIDEuNTQtLjg0MXpNNyA0LjgzMnYxNC4zMzZMMTguMTUgMTIgNyA0LjgzMnoiICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  M as default
};
//# sourceMappingURL=play-c754fa9b.mjs.map
